import PropTypes from 'prop-types';
import formatNumber from '../../utils/format-number';
import { getAnnualDiscount, getMonthlyEquivalentPrice } from '../../utils/billing-utils';

export default function AnnualDiscount({ comparablePrice, suitablePrice }) {
    const referencePrice = comparablePrice ?? suitablePrice;
    const annualDiscount = getAnnualDiscount(referencePrice, suitablePrice);

    if (!annualDiscount) {
        return null;
    }

    return (
        <>
            <div className="grey">
                <span>Yearly price</span>
                <span>
                    {formatNumber(getMonthlyEquivalentPrice(referencePrice, suitablePrice) * 12, {
                        symbol: '$',
                    })}
                </span>
            </div>
            <div className="green highlighted">
                <span>
                    <strong>
                        {getAnnualDiscount(referencePrice, suitablePrice, { percentage: true })}%
                    </strong>{' '}
                    discount
                </span>
                <span>
                    -
                    {formatNumber(annualDiscount, {
                        symbol: '$',
                    })}
                </span>
            </div>
        </>
    );
}

const pricePropType = PropTypes.shape({
    cost: PropTypes.number,
    billing_period: PropTypes.string,
});

AnnualDiscount.propTypes = {
    comparablePrice: pricePropType,
    suitablePrice: pricePropType,
};
